import { Group, Stack, Text, Title } from "@mantine/core";
import type { ReactNode } from "react";

/**
 * A page's title row: the title (an h3 whose text is exactly `title`), a muted line under it, and
 * the page's controls on the right.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
  subtitleTestId,
}: {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
  subtitleTestId?: string;
}) {
  return (
    <Group justify="space-between" align="flex-end" wrap="wrap" gap="md" mb={4}>
      <Stack gap={2}>
        <Title order={3}>{title}</Title>
        {subtitle !== undefined && (
          <Text size="sm" c="dimmed" data-testid={subtitleTestId}>
            {subtitle}
          </Text>
        )}
      </Stack>
      {actions !== undefined && (
        <Group gap="sm" wrap="wrap">
          {actions}
        </Group>
      )}
    </Group>
  );
}
